<template>
  <div class="stationItem">
    <div class="workAreaMapWrapper" @click="go">
      <div class="workAreaMap">
        <!-- <div class="workAreaName">{{ item.workAreaSetting.workAreaName }}</div> -->
        <div class="freeCount">
          <!-- <img class="freeCountIcon" src="@/assets/images/bubble-1.png" /> -->
          {{ $t('剩余') }}{{ item.stationLeisureCount }}{{ $t('空位') }}
        </div>
        <div class="workAreaContent">
          <div class="workAreaCanvas">
            <img :src="item?.workAreaSetting?.planeMap || defaultImg" />
            <div class="statinXYItem" v-for="statinXYItem in item.stationStatusList" :key="statinXYItem.id" :style="{
              top: statinXYItem.top * clientRatio + 'px',
              left: statinXYItem.left * clientRatio + 'px',
              width: statinXYItem.width * clientRatio + 'px',
              height: statinXYItem.height * clientRatio + 'px',
            }">
              <img class="statinXYItemIcon" :src="statinXYItem.src" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StationItem',
  data() {
    return {
      defaultImg: require('@/assets/images/default_image.png'),
      clientRatio: document.body.clientWidth / 375, // 以375为模版，匹配在不同屏幕上的缩放比例
    }
  },
  methods: {
    go() {
      //跳转至工位预约设置页面
      this.$router.push({
        name: 'stationAppointment',
        // path: `/station/stationAppointment`,
        params: {
          startTime: `${this.item.date} ${this.item.startTime}`,
          endTime: `${this.item.date} ${this.item.endTime}`,
          workspaceId: this.item.workAreaSetting.workspaceId,
          workAreaId: this.item.workAreaId,
        },
      })
    },
  },
  mounted() {
    console.log(
      'document.body.clientWidth / 375:',
      document.body.clientWidth / 375
    )
  },
  props: ['item', 'area'],
}
</script>
<style lang="less" scoped>
.stationItem {
  .workAreaMapWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .freeCount {
      font-size: 12px;
      font-weight: 400;
      align-self: flex-start;
      margin-left: 16px;
      // margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      color: #707A8A;
      line-height: 20px;

      .freeCountIcon {
        width: 16px;
        height: 16px;
        vertical-align: bottom;
      }
    }

    .workAreaMap {
      .workAreaName {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        text-indent: 8px;
      }

      margin-top: 10px;
      width: 100%;

      .workAreaContent {
        margin-top: 100px;
        width: 100%;
        // height: 204px;
        background: #fefffe;
        // box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .workAreaCanvas {
          width: 346.7px;
          position: relative;

          img {
            width: 100%;
          }

          .statinXYItem {
            position: absolute;

            .statinXYItemIcon {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>
